import * as MockAdminService from "./MockAdminService"
import * as AdminService from "./AdminService"
const ApiService = AdminService || MockAdminService;

export default ApiService;

